import PropTypes from 'prop-types';
import { useSoyuzExperiment, trans } from '@spotahome/soyuz/client';

import { Button } from '@spotahome/ui-library';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';

import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import { getRnaIdFeature } from '../../utils/legalFeaturesAdapter';

import { ListingSectionObservable } from '../ListingSection';

import openListingDescriptionsModal from './ListingDescriptionsModal';

import './ListingDescriptions.scss';

const ListingDescriptions = ({
  listing,
  description = '',
  landlordDescription = '',
  roomDescription = '',
  whatWeLiked = '',
  thingsToKeepInMind = '',
  bordered = false
}) => {
  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeaderV2').get('behaviour') ===
    'variant';

  const rnaIdFeature = getRnaIdFeature(
    listing.type,
    listing.propertyFeatures,
    listing.unitFeatures
  );

  if (!isListingSimplificationHeaderVariant) {
    return null;
  }

  return (
    <ListingSectionObservable
      section="listing-descriptions"
      className="listing-descriptions"
      bordered={bordered}
    >
      <ListingTitle role="secondary">
        {trans('listing.descriptions.title')}
      </ListingTitle>
      {(roomDescription || description || landlordDescription) && (
        <div className="listing-descriptions__description-preview">
          <ListingContent
            className="listing-descriptions__description-preview-text"
            content={roomDescription || description || landlordDescription}
          />
        </div>
      )}
      <Button
        type="button"
        className="listing-descriptions__read-more"
        color="link"
        onClick={() =>
          openListingDescriptionsModal({
            listingDescription: description,
            landlordDescription,
            roomDescription,
            whatWeLiked,
            thingsToKeepInMind,
            rnaIdFeature,
            fullscreenOnMobile: true
          })
        }
      >
        {trans('common.view-more')}
      </Button>
    </ListingSectionObservable>
  );
};

ListingDescriptions.propTypes = {
  listing: PropTypes.shape({
    type: PropTypes.string,
    propertyFeatures: PropTypes.object,
    unitFeatures: PropTypes.object
  }).isRequired,
  description: PropTypes.string,
  landlordDescription: PropTypes.string,
  roomDescription: PropTypes.string,
  whatWeLiked: PropTypes.string,
  thingsToKeepInMind: PropTypes.string,
  bordered: PropTypes.bool
};

export default ListingDescriptions;
